import React, { useState } from 'react';
import { Share2, Check } from 'lucide-react';
import { trackShare } from '../utils/analytics';

/**
 * Megosztás gomb.
 *
 * Mobilon a natív megosztó lapot nyitja (Web Share API) – ott a felhasználó a
 * saját alkalmazásait látja (Messenger, WhatsApp, üzenetek). Ahol ez nincs
 * (asztali böngészők többsége), a link a vágólapra kerül, és a gomb rövid
 * visszajelzést ad. Mindkét ág mérve van (`share` esemény, method=native|copy).
 *
 * @param title/text  a megosztott tartalom címe és rövid leírása
 * @param url         megosztandó URL (alapértelmezés: az aktuális oldal)
 * @param ctx         analytics-kontextus (model, device_id, price…)
 */
export default function ShareButton({
  title = '',
  text = '',
  url,
  ctx = {},
  className = '',
  label = 'Megosztás',
}) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
    try {
      if (typeof navigator !== 'undefined' && navigator.share) {
        await navigator.share({ title, text, url: shareUrl });
        trackShare('native', ctx);
        return;
      }
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      trackShare('copy', ctx);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      // A felhasználó megszakította a megosztást (AbortError) – ez NEM hiba,
      // és nem is mérjük; minden más esetben jelezzük.
      if (e && e.name === 'AbortError') return;
      trackShare('error', ctx);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleShare}
        /* A korábbi statikus aria-label elnyomta a látható „Link másolva”
           váltást – az accessible name most a látható szövegből jön. */
        data-testid="share-button"
        className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full border border-gray-200 bg-white text-sm font-semibold text-gray-700 hover:border-brand hover:text-brand-hover transition-colors ${className}`}
      >
        {copied ? <Check size={16} className="text-brand" /> : <Share2 size={16} />}
        {copied ? 'Link másolva' : label}
      </button>
      {/* Stabil, mindig jelen lévő élő régió: a sikeres másolást a
          képernyőolvasó akkor is bemondja, ha a gombfelirat-váltást nem követné. */}
      <span role="status" className="sr-only">{copied ? 'A link a vágólapra került.' : ''}</span>
    </>
  );
}
